module.exports = __webpack_public_path__ + "6c0ddf4b84a6c241a87b423f6181c823.MP3";